import axios from 'axios';

// http://localhost:3002
// https://api.safe-tasker.com/api

export const api = axios.create({
  baseURL: "https://api.safe-tasker.com/api",
});

export const setAuthHeader = (token: string) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const clearAuthHeader = () => {
  delete api.defaults.headers.common.Authorization;
};
